<template>
    <div class="list-mode">
        <div class="left">
            <div class="list-wrap">
                <tabs>
                    <tab name="房源" :selected="selected.house">
                        <todo-house v-if="selected.house"></todo-house>
                    </tab>
                    <tab name="預定" :selected="selected.booking">
                        <todo-booking v-if="selected.booking"></todo-booking>
                    </tab>
                    <tab name="租約" :selected="selected.lease">
                        <todo-lease v-if="selected.lease"></todo-lease>
                    </tab>
                    <tab name="委託房客" :selected="selected.task">
                        <todo-task v-if="selected.task"></todo-task>
                    </tab>
                </tabs>
            </div>
        </div>
        <div class="right">
            <div class="filter" :class="{'fixed': filterIsFixed}">
                <div class="filter-title">
                    <span>
                        <img src="@/assets/img/icon/filter_gray.svg" alt="">
                        篩選
                    </span>
                    <span v-show="filterState" class="clear-filter" @click="setFilterDefault">
                        清除篩選
                    </span>
                </div>
                <div class="filter-group">
                    <span class="title">業務分群</span>
                    <rent-select refName="orgGroup" style="margin-bottom: 16px;" selectMsg="全部" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefault">
                        <ul>
                            <li v-for="(item, index) in groupList" :key="index" :data-id="item.id" :data-name="item.groupName">
                                {{item.groupName}}
                            </li>
                        </ul>
                    </rent-select>
                    <span class="title">業務</span>
                    <rent-select refName="member" selectMsg="全部" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefault  || isGroupChange">
                        <ul>
                            <li v-for="(item, index) in memberList" :key="index" :data-id="item.userCid" :data-name="item.name">
                                {{item.name}}
                            </li>
                        </ul>
                    </rent-select>
                </div>
                <div class="filter-location">
                    <div class="title level1-title-font">地點</div>
                    <div class="group">
                        <rent-select class="select-scroll" refName="county" selectMsg="所有縣市" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefault">
                            <ul>
                                <li :data-id="index" :data-name="county" v-for="(county, index) in countyResult" :key="index">
                                    {{county}}
                                </li>
                            </ul>
                        </rent-select>
                        <rent-select class="select-scroll" refName="district" selectMsg="所有區域" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefault || isCityChange">
                            <ul v-if="filter.countyId">
                                <li :data-id="index" :data-name="district.districtName" v-for="(district, index) in districtsResult" :key="index">
                                    {{district.districtName}}
                                </li>
                            </ul>
                        </rent-select>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import VueSlider from 'vue-slider-component'
import RentSelect from '@/components/bussiness/widges/tools/RentSelect.vue';
import DatePicker from 'vue2-datepicker';
import Tabs from '@/components/widge/Tabs.vue';
import Tab from '@/components/widge/Tab.vue';
import todoHouse from '@/components/bussiness/personalHome/home/todoList/todoHouse.vue';
import todoBooking from '@/components/bussiness/personalHome/home/todoList/todoBooking.vue';
import todoLease from '@/components/bussiness/personalHome/home/todoList/todoLease.vue';
import todoTask from '@/components/bussiness/personalHome/home/todoList/todoTask.vue';

import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            filter: {
                groupId: '',
                memberId: '',
                county: '',
                district: '',
            },
            selected: {
                house: false,
                booking: false,
                lease: false,
                task: false,
            },
            isGroupChange: false,
            isCityChange: false,
            filterState: 0,
            filterIsFixed: false,
            isDefault: false,
            componentKey: 0
        }
    },
    watch: {
        filter: {
            handler: function (val){
                this.$store.dispatch('setBizTodoListFilter', val)
            },
            deep: true
        },
        $route:{
            handler: function (val) {
                this.hash = val.hash
                this.forceUpdate()
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        getSelectId: function (value) {
            this.filterState = 1
            this.isDefault = false
            if( value.ref == 'orgGroup' ){
                this.filter.groupId = value.id
                this.$store.dispatch('getBizMemberByGroupList',(value.id))
                this.isGroupChange = true
                this.filter.memberId = ''
            }else if( value.ref == 'member' ){
                this.filter.memberId = value.id
                this.isGroupChange = false
            }else if( value.ref == 'county' ){
                this.filter.county = value.name
                this.filter.countyId = value.id
                this.isCityChange = true
                this.filter.district = ''

                this.$store.dispatch('getDistrict',(parseInt(value.id)+1))
            }else if( value.ref == 'district' ){
                this.isCityChange = false
                this.filter.district = value.name
            }
        },
        closeTaskMenu: function (value) {
            this.taskMenu = value
        },
        setFilterDefault: function () {
            let data = {
                groupId: '',
                memberId: '',
                county: '',
                district: '',
            }
            this.filter = data
            this.isDefault = true
            setTimeout(()=>{
                this.filterState = 0
                this.isDefault = false
            },100)
        },
        handleScroll: function () {
            // console.log(event.path[1].scrollY)
            if( event.path[1].scrollY >= 178){
                this.filterIsFixed = true
            }else{
                this.filterIsFixed = false
            }
        },
        numValue: function (val) {
            if( val == '100000' ){
                return '$'+this.toCurrency(val)+'+'
            }else{
                return '$'+this.toCurrency(val)
            }
        },
        selectTabByHash: function () {
            let hashTag = decodeURIComponent(this.$route.hash)
            if( hashTag == '#房源' ){
                this.selected.house = true
            }else if( hashTag == '#預定' ){
                this.selected.booking = true
            }else if( hashTag == '#租約' ){
                this.selected.lease = true
            }else if( hashTag == '#委託房客'){
                this.selected.task = true
            }else{
                this.selected.house = true
            }
        },
        setSelectTabAllFalse: function () {
            this.selected.house = false
            this.selected.booking = false
            this.selected.lease = false
            this.selected.task = false
            
        },
        forceUpdate: function () {
            this.setSelectTabAllFalse()
            this.selectTabByHash()
            this.componentKey += 1; 
        }
    },
    computed: {
        ...mapGetters({
            filterQuery: 'BIZ_TODO_LIST_GRAPH_FILTER_QUERY',
            houseResult: 'BIZ_TODO_LIST_GRAPH_HOUSE_RESULT',
            houseIsLoading: 'BIZ_TODO_LIST_GRAPH_HOUSE_STATUS_LOADING',
            groupList: 'GET_ORG_GROUP_LIST',
            memberList: 'GET_ORG_MEMBER_BY_GROUP_LIST',
            countyResult: 'COUNTY_RESULT',
            districtsResult: 'DISTRICTS_RESULT',
        })
    },
    components: {
        VueSlider,
        DatePicker,
        RentSelect,
        Tabs,
        Tab,
        todoBooking,
        todoHouse,
        todoLease,
        todoTask,

    }
}
</script>
<style lang="scss">
    .list-mode{
        display: flex;
        justify-content: space-between;
        .left{
            width: 850px;
            .tabs{
                padding: 0 24px;
                margin-top: 20px;
                margin-bottom: 28px;
            }
            .list-wrap{
                border-radius: 6px;
                backdrop-filter: blur(10px);
                box-shadow: 1px 0 10px 0 rgba(41, 38, 37, 0.02);
                border: solid 1px #f3f3f3;
                background-color: #ffffff;
                padding-bottom: 10px;
            }
        }
        .right{
            position: relative;
            width: 270px;
            .clear-filter{
                position: absolute;
                cursor: pointer;
                font-size: 12px;
                color: #ff9275;
                top: 24px;
                right: 17px;
            }
            .filter::-webkit-scrollbar{
                display: none;
            }
            .filter{
                position: relative;
                width: 270px;
                background: #fff;
                border-radius: 8px;
                border: solid 1px #f0f0f0;
                padding: 20px 0px 25px 0px;
                .title{
                    display: block;
                    font-size: 16px;
                    margin-bottom: 16px;
                }
                .filter-title,
                .filter-group,
                .filter-location
                {
                    padding: 0 20px 20px 20px;
                    border-bottom:2px solid #f6f6f6 ;
                }
                .filter-group{
                    padding-top: 20px;
                }
                .filter-title{
                    span:nth-child(1){
                        display: flex;
                        align-items: center;
                        color: #a8a5a4;
                        img{
                            margin-right: 8px;
                        }
                    }
                }
                .filter-location{
                    padding-top: 20px;
                    .group{
                        display: flex;
                        .biz-rent-select:nth-child(1){
                            margin-right: 10px;
                        }
                        .biz-rent-select{
                            width: 83px;
                            height: 18px;
                        }
                    }
                    
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/personalHome/todoList/listMode/listMode.vue